import WelfareAssistant from "./components/WelfareAssistant";
import "./App.css";
import "./components/sitcky.css";

function App() {
  return (
    <div className="App">
      <WelfareAssistant />
    </div>
  );
}

export default App;
